/**
 * Project Role Constants and Enums
 * Defines project role IDs and helper constants for role-based access control
 * Maps to lkp_project_role table in database
 */

export enum ProjectRole {
  ADMIN = 1,
  USER = 2,
  READONLY = 3,
  INTEGRATOR = 4,
  CUSTOMER = 5
}

/**
 * Project roles with full administrative access
 */
export const ADMIN_PROJECT_ROLES: ProjectRole[] = [ProjectRole.ADMIN, ProjectRole.USER];

/**
 * Project role names mapping
 */
export const PROJECT_ROLE_NAMES: Record<ProjectRole, string> = {
  [ProjectRole.ADMIN]: 'Admin',
  [ProjectRole.USER]: 'User',
  [ProjectRole.READONLY]: 'ReadOnly',
  [ProjectRole.INTEGRATOR]: 'Integrators',
  [ProjectRole.CUSTOMER]: 'Customer'
};
